/* eslint-disable sort-imports */
/* globals $:false */

import utils from '@cob/ui-genesis/cob.utils.js';
import InstanceActions from "../actions/recordm.actions.instance";
import UriBuilder from "../helpers/module.uribuilder.js";
import DefinitionM from "../model/recordm.model.entity.definition.js";
import SearchVisGroupM from "../model/recordm.model.searchvisgroup.js";
import SimpleSearchM from "../model/recordm.model.simplesearch.js";
import DefinitionSearchResultP from "../presenter/recordm.presenter.searchresult.definition.js";
import SimpleSearchP from "../presenter/recordm.presenter.simplesearch.js";
import tmpl_searchlist from '../templates/instance-field-references.dot';

// Component capable of showing RecordM instances that have fields referring the given instance field
// This is based on "recordm.fields.references.js" but more simple just to be used in dashboards
//
// container: The css container to attach the search result
// definitionName: the Definition name
// query: the Definition name
//
// confs:
// * 'showViews':  enables the visualizations functionality (default: false)
// * 'activeVisualizationName': the visualization to apply to the search results (default: undefined)
// * 'showActions': shows the mass and instance actions buttons (default: false)
// * 'showImport': shows the button to allow the user to import a file
// * 'showCreateAndDelete': shows the button for in-line instance creation (default: true)
// * `allowRowSelection`: should show the checkboxes to select rows
// * `showDetailsColumns`: Should show the Details column
// * `showColumnsSelector`:Should show the toggle to show hidden columns
//
const SimpleSearch = function(core, container, definitionName, query, confs) {

    const _confs = {
        showViews: false,
        activeVisualizationName: undefined,
        showActions: false,
        showImport: false,
        showCreateAndDelete: true,
        allowRowSelection: true,
        showDetailsColumns: true,
        showColumnsSelector: true
    };

    utils.extend(_confs, confs, true);

    const fix_bool_option = function(opt) {
        if (typeof opt == "string") {
            return (opt === "true" || opt === "1");
        }
        return opt;
    };
    _confs.showViews = fix_bool_option(_confs.showViews);

    _confs.showActions = fix_bool_option(_confs.showActions);
    _confs.showImport = fix_bool_option(_confs.showImport);
    _confs.showCreateAndDelete = fix_bool_option(_confs.showCreateAndDelete);
    _confs.allowRowSelection = fix_bool_option(_confs.allowRowSelection);
    _confs.showDetailsColumns = fix_bool_option(_confs.showDetailsColumns);
    _confs.showColumnsSelector = fix_bool_option(_confs.showColumnsSelector);

    console.log("### HM", _confs);

    const _$field = $(tmpl_searchlist({
        defSearchUrlText: core.translateString("recordm.instances", "instance.field.searchList.goto-def-search-url")
    }));

    let _searchP,
        _searchResultP,
        _definitionM,
        _simpleSearchM,
        _groupEdit,
        _activeVisualizationId;

    // let _rendered = false
    let _query = query;

    // If the search field value has placeholders, we do not define a query to prevent
    // showing results to the user while the search field value has placeholders
    const _getUrlForDefinitionSearch = function(defId, query) {
        return "#/" + UriBuilder.buildUriForSimpleSearchDefinition(defId, query, _activeVisualizationId);
    };

    const _removeUnnecessarySearchResultsHtml = function() {
        if (!_confs.showActions) {
            // Remove the batch actions container, as it won't show any available option
            // It also improves the custom data elements (added in customizations scripts) location
            $(".js-mass-actions-left-container", _$field).children().remove()
        }

        if (!_confs.showActions && !_confs.showImport) {
            $(".js-mass-actions", _$field).remove();
        }

        if (!_confs.showViews) {
            //Remove the view selection info container
            $(".result-views-container", _$field).remove();
        } else {
            $(".result-views-container").addClass("pull-right")
        }
    };

    const _updateTotalResults = function(numResults) {
        $(container + " > div.references-wrapper > div.references-legend > span.js-total-records").text(numResults);
    };

    const _updateGoToSearchLink = function() {
        $(".js-def-search-link", _$field).attr("href", _getUrlForDefinitionSearch(_definitionM.getId(), _query));
    };

    const _getActiveVisualizationIdByName = function(viewName, views) {
        const viewM = views.find((settingM) => settingM.getKey() === viewName);

        return (viewM !== undefined
                ? viewM.getId()
                : undefined);
    };

    const _onSearchFinished = function() {
        const numResults = _simpleSearchM.getTotalMatchingResults();

        _updateTotalResults(numResults);
    };

    const _onSelectedRowsChanged = function(e, data) {
        if (!_groupEdit) return;
        const geditIds = _groupEdit.getIds() ? _groupEdit.getIds() : "";

        if ((geditIds === "" && data.selectedIds.length > 0)
            || geditIds.split(",").length !== data.selectedIds.length
            || _groupEdit.getQuery() !== data.query) {

            _groupEdit.updateSelectedIds(data.allSelected ? data.query : undefined, data.selectedIds)
        }
    }

    const _initDefinitionPs = function(views) {
        const visualizationGroupM = new SearchVisGroupM(core, _definitionM, views);

        _activeVisualizationId = (_confs.activeVisualizationName
                                  ? _getActiveVisualizationIdByName(_confs.activeVisualizationName, views)
                                  : undefined);

        const activeVisualization = (_activeVisualizationId
                                     ? visualizationGroupM.get(_activeVisualizationId)
                                     : undefined);

        _simpleSearchM = new SimpleSearchM(
            core,
            "recordm/definitions/search/" + _definitionM.getId(),
            "recordm/definitions/search/download/" + _definitionM.getId()
        );

        const $resultsContainer = $(".js-def-search-result-container", _$field);

        _searchP = new SimpleSearchP(core, undefined, _definitionM, _simpleSearchM, undefined,
            {"advance-search": false},
            {
                getCurrentVisualization: function() {
                    return activeVisualization;
                }
            });


        const _instanceActions = new InstanceActions(core, {
            disableDelete: !_confs.showCreateAndDelete,
            disableGroupDelete: !_confs.showActions,
            disableGroupEdit: !_confs.showActions
        })

        _searchResultP = new DefinitionSearchResultP(core, _simpleSearchM, _definitionM, visualizationGroupM,
            _instanceActions, $resultsContainer, {
                canCreateNewRecord: _confs.showCreateAndDelete && _definitionM.data._links && _definitionM.data._links.instantiate,
                canDuplicate: _confs.showActions && _confs.showCreateAndDelete && _definitionM.data._links && _definitionM.data._links.instantiate,
                canImportRecords: _confs.showImport,
                canPrint: false,
                allowRowSelection: _confs.allowRowSelection,
                showDetailsColumns: _confs.showDetailsColumns,
                showColumnsSelector: _confs.showColumnsSelector
            });

        _searchP.init(query);
        _searchResultP.init(query, _activeVisualizationId);

        core.subscribe("definition-search:results-ready", _onSearchFinished);
        core.subscribe("recordm:search-selection-changed", _onSelectedRowsChanged);
    };

    const _init = function() {
        DefinitionM.getByName(core, definitionName, function(definitionM) {
            _definitionM = definitionM;

            SearchVisGroupM.loadAll(core, definitionM.getSettingKey(), function(views) {
                _initDefinitionPs(views);

                _removeUnnecessarySearchResultsHtml();

                const hasCreationPerm = definitionM.data._links && definitionM.data._links.instantiate;
                if (_confs.showCreateAndDelete && hasCreationPerm) {
                    $(".js-references-new-instance-link", _$field).removeClass("hidden");
                } else {
                    $(".js-references-new-instance-link", _$field).remove();
                }

                //Update the "open in new tab" link href
                _updateGoToSearchLink();

                // Attach the component to the container
                const _$container = $(container);
                _$container.append(_$field)
                _$container.css({overflow: "visible"})
            });
        });
    };

    const _destroy = function() {
        _$field.remove();

        $(container).off("click");

        core.unsubscribe("recordm:search:finished", _onSearchFinished);
        core.unsubscribe("recordm:search-selection-changed", _onSelectedRowsChanged);

        if (_searchP) _searchP.destroy();
        if (_searchResultP) _searchResultP.destroy();
    };

    _init();

    return {
        destroy: _destroy,

        setSearchValue: function(newQuery) {
            if (newQuery !== _query) {
                _query = newQuery;

                if (_searchP) _searchP.doSearch(_query);
            }

            if (_definitionM) {
                _updateGoToSearchLink();
            }
        },

        refresh: function() {
            _searchP.refresh()
        },

        refreshGrid: function () {
            if (_searchResultP) {
                _searchResultP.prepareView()
            }
        }
    }
};

export default SimpleSearch;
